import moment from "moment";
import DatePicker from "vue2-datepicker";
import StoreGetter from "@/constants/StoreGetter";
import SweetAlertService from "@/service/SweetAlertService";
import { datePickerLang } from "@/constants/globalConstants";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import Settings from "../../../../constants/Settings.js";
import ShiftTypeService from "@/service/ShiftTypeService";
import RosterService from "@/service/RosterService";
import { Roster } from "@/model/Roster";
import ArrayHelper from "@/common/helper/ArrayHelper";
export default {
  name: "staffRosterView",
  components: {
    DatePicker
  },
  props: ["staffModel", "isViewMode"],
  data: () => ({
    t: t,
    dictEnum: dictEnum,
    Settings: Settings,
    moment: moment,
    lang: datePickerLang,
    date: moment().format(Settings.DateTime.yyyymmdd),
    tableHeader: [],
    tableData: [],
    shiftTypeList: [],

    genRosterDate: moment().format("YYYY-MM"),

    type: "month",
    typeToLabel: {
      month: "Month",
      week: "Week",
      day: "Day",
      "4day": "4 Days"
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    colors: [
      "blue",
      "indigo",
      "deep-purple",
      "cyan",
      "green",
      "orange",
      "grey darken-1"
    ],
    names: [
      "Meeting",
      "Holiday",
      "PTO",
      "Travel",
      "Event",
      "Birthday",
      "Conference",
      "Party"
    ]
  }),
  computed: {
    user() {
      return this.$store.getters[StoreGetter.user];
    },
    disabledMode() {
      return this.isViewMode;
    },
    computeRoster: function() {
      if (this.tableData.length === 0) {
        return new Map();
      }
      return new Map(
        this.tableData[0].Roster.map(item => [item.DateWork, item])
      );
    }
  },
  mounted() {
    this.getDayHead();
    this.getShiftType();
    this.$refs.calendar.checkChange();
    if (this.staffModel.StaffID) this.getRoster();
  },
  methods: {
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },

    getRouterShareCode(list, date) {
      const find = list.find(x => {
        return (
          moment(x.DateWork).format(Settings.DateTime.yyyymmdd) ==
          moment(date).format(Settings.DateTime.yyyymmdd)
        );
      });
      if (find) {
        return find.ShiftCode;
      }
    },

    routerShareColor(result) {
      let color = "white";
      const find = this.shiftTypeList.find(x => {
        return x.ShiftCode == result;
      });
      if (find) {
        color = find.Color;
      }
      return color;
    },

    getWeek(date) {
      let week = moment(date).day();
      const weekList = ["S", "M", "T", "W", "T", "F", "S"];
      const weekValue = weekList[week];
      return weekValue;
    },

    getDay(date) {
      return moment(date).format("MM-DD");
    },

    weekdayFormatter(timestamp) {
      switch (timestamp.weekday) {
        case 1:
          return this.t.t(dictEnum.LBL_Mon);
        case 2:
          return this.t.t(dictEnum.LBL_Tue);
        case 3:
          return this.t.t(dictEnum.LBL_Wed);
        case 4:
          return this.t.t(dictEnum.LBL_Thu);
        case 5:
          return this.t.t(dictEnum.LBL_Fri);
        case 6:
          return this.t.t(dictEnum.LBL_Sat);
        case 0:
          return this.t.t(dictEnum.LBL_Sun);
      }
    },

    async getDayHead(date) {
      if (date) {
        let startDay = moment(date)
          .startOf("month")
          .format(Settings.DateTime.yyyymmdd);
        let endDay = moment(date)
          .endOf("month")
          .format(Settings.DateTime.yyyymmdd);
        let daylist = [];
        const days = moment(endDay).diff(startDay, "days");
        daylist.push(startDay);
        for (let i = 1; i <= days; i++) {
          daylist.push(
            moment(startDay)
              .add(i, "days")
              .format(Settings.DateTime.yyyymmdd)
          );
        }
        return daylist;
      }
    },

    async getShiftType() {
      const obj = {};

      const response = await ShiftTypeService.getShiftType(obj);
      if (response.data.IsSuccess) {
        this.shiftTypeList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    editRoster(roster) {
      this.roster = roster;
    },

    async getRoster() {
      console.log(this.date, "----this.date");
      const obj = {
        date: moment(this.date).format("YYYY-MM"),
        deptID: this.staffModel.Dept,
        compCode: this.staffModel.CompCode,
        staffName: ""
      };

      const response = await RosterService.getRoster(obj);
      if (response.data.IsSuccess) {
        let staffDatas = response.data.Data.filter(
          x => x.StaffID == this.staffModel.StaffID
        );

        const dataBet = await this.getDayHead(this.date);

        for (const staff of staffDatas) {
          const list = dataBet.map(x => {
            let roster = new Roster();
            roster.StaffID = staff.StaffID;
            roster.DateWork = x;
            staff.Roster.forEach(r => {
              if (moment(r.DateWork).format(Settings.DateTime.yyyymmdd) == x) {
                roster.ShiftCode = r.ShiftCode;
                roster.SysDB = true;
              }
            });
            return roster;
          });
          list = ArrayHelper.sortByKey(list, "DateWork");
          staff.Roster = list;
        }
        this.tableHeader = dataBet;
        this.tableData = staffDatas;
        this.$refs.calendar.checkChange();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async saveRoster() {
      let list = [];
      this.tableData.forEach(x => {
        list = list.concat(x.Roster);
      });
      list = list.filter(x => x.ShiftCode);
      if (list.length == 0) return;
      const obj = {
        lisRoster: list
      };
      const response = await RosterService.import(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    openGenRoster() {
      $("#genModel").modal("show");
    },
    hideGenRoster() {
      $("#genModel").modal("hide");
    },
    async genRoster() {
      const obj = {
        compCode: this.staffModel.CompCode,
        staffID: [this.staffModel.StaffID],
        dateFrom: moment(this.genRosterDate)
          .startOf("month")
          .format(Settings.DateTime.yyyymmdd),
        dateTo: moment(this.genRosterDate)
          .endOf("month")
          .format(Settings.DateTime.yyyymmdd)
      };
      const response = await RosterService.genRoster(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
        $("#genModel").modal("hide");
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
        $("#genModel").modal("hide");
      }
    },

    changeDate() {
      var self = this;
      // self.searchData.staffName = "";
      // self.searchData.staffID = "";
    },

    deleteRoster() {},

    changePage(bol) {
      const num = bol ? 1 : -1;
      this.date = moment(this.date)
        .add(num, "months")
        .format(Settings.DateTime.yyyymmdd);
      if (bol === 1) {
        this.next();
      } else {
        this.prev();
      }
      this.getRoster();
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/S070000-Employee/S070200-EmployeeProfile/StaffRoster/StaffRosterView.js